import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { CORE_QUERY_KEYS as INVENTORY_QUERY_KEYS } from 'app/hooks/data/core/extranet/inventory';
import type {
  CalendarPeriod,
  CalendarSlotSeries,
  UpdateSeriesPayload,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUpdateSeries(
  hotelId?: number,
  calendarId?: number,
  period?: CalendarPeriod
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      seriesId,
      payload,
    }: {
      seriesId: number;
      payload: UpdateSeriesPayload;
    }) =>
      hotelId !== undefined && calendarId !== undefined
        ? (apiMutation(
            'PUT',
            {
              path: ENDPOINTS.updateSeries,
              params: {
                hotelId: hotelId.toString(),
                calendarId: calendarId.toString(),
                seriesId: seriesId.toString(),
              },
              queryParams: {
                startDate: period?.startDate,
                endDate: period?.endDate,
              },
            },
            payload
          ) as Promise<CalendarSlotSeries>)
        : Promise.reject(null),
    onSuccess: () => {
      message.success('Recurring availability successfully updated');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.calendar, { hotelId, calendarId }],
      });

      queryClient.invalidateQueries({
        queryKey: [INVENTORY_QUERY_KEYS.inventory, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to update recurring availability.');
    },
  });
}
